module.exports = __webpack_public_path__ + "img/ctrl-canonical-stub-mid-1.212135dc.svg";